exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".info-field-value[data-v-a93619f4]{width:100%}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Software/AddRequirement.vue"],"names":[],"mappings":"AACA,mCACI,UAAY,CACf","file":"AddRequirement.vue","sourcesContent":["\n.info-field-value[data-v-a93619f4] {\n    width: 100%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a93619f4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/Software/AddRequirement.vue
// module id = 2376
// module chunks = 14